import React from 'react';
import { Link } from 'react-router-dom';
import { dummyStoreInfo } from '../dummyData';

const TemplateFooter = ({ colors = {}, websiteData = {} }) => {
    return (
        <footer className="bg-white">
            <div className="container py-100 my-3">
                <div className="row">
                    {/* Left: Logo */}
                    <div className="col-lg-4 mb-20 mb-lg-0 text-center text-lg-start">
                        <div className="d-inline-block text-center">
                            <img
                                src={websiteData?.websiteLogo || dummyStoreInfo.logo}
                                alt="Company Logo"
                                style={{ maxHeight: '48px', objectFit: 'contain' }}
                                className="mb-2"
                            />
                            <p className="text-12 text-gray-500 mb-0">
                                Powered by <span className="text-danger fw-medium">iwant Asia</span>
                            </p>
                        </div>
                    </div>

                    {/* Middle 1: Links */}
                    <div className="col-lg-2 col-6 mb-20 mb-lg-0">
                        <ul className="list-unstyled text-12 d-flex flex-column gap-10 mb-0">
                            <li>
                                <Link to="/" className="text-gray-500 text-decoration-none hover-text-primary fw-medium">
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link to="/products" className="text-gray-500 text-decoration-none hover-text-primary fw-medium">
                                    Product
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact-us" className="text-gray-500 text-decoration-none hover-text-primary fw-medium">
                                    Contact Us
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Middle 2: Links */}
                    <div className="col-lg-2 col-6 mb-20 mb-lg-0">
                        <ul className="list-unstyled text-12 d-flex flex-column gap-10 mb-0">
                            <li>
                                <Link to="/account" className="text-gray-500 text-decoration-none hover-text-primary fw-medium">
                                    My Account
                                </Link>
                            </li>
                            <li>
                                <Link to="#" className="text-gray-500 text-decoration-none hover-text-primary fw-medium">
                                    Customer Services
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Right: Social */}
                    <div className="col-lg-4 d-flex flex-column align-items-lg-end text-center text-lg-end">
                        <div className="d-flex flex-column align-items-center">
                            <h6 className="fw-bold mb-10 text-14" style={{ color: '#121212' }}>
                                Get In Touch with Us
                            </h6>
                            <div className="d-flex gap-6 justify-content-center justify-content-lg-end">
                                {/* Social icons */}
                                {websiteData?.socialMediaList?.map((social, index) => {
                                    let iconClass = '';
                                    let style = { width: '28px', height: '28px' };

                                    switch (social.type) {
                                        case 0: // WhatsApp
                                            iconClass = 'ph-whatsapp-logo';
                                            style.backgroundColor = '#25D366';
                                            break;
                                        case 1: // Instagram
                                            iconClass = 'ph-instagram-logo';
                                            style.background =
                                                'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)';
                                            break;
                                        case 2: // Facebook
                                            iconClass = 'ph-facebook-logo';
                                            style.backgroundColor = '#1877F2';
                                            break;
                                        case 3: // TikTok
                                            iconClass = 'ph-tiktok-logo';
                                            style.backgroundColor = '#000000';
                                            break;
                                        case 4: // Telegram
                                            iconClass = 'ph-telegram-logo';
                                            style.backgroundColor = '#0088cc';
                                            break;
                                        default:
                                            return null;
                                    }

                                    return (
                                        <a
                                            key={index}
                                            href={social.url || social.link || '#'}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="rounded d-flex align-items-center justify-content-center text-white text-decoration-none"
                                            style={style}
                                        >
                                            <i className={`ph-fill ${iconClass} text-16`}></i>
                                        </a>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* bottom footer */}
            <div className="py-20" style={{ backgroundColor: colors.footerBg || '#000', color: colors.footerColor || '#fff' }}>
                <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center text-10">
                    <p className="mb-2 mb-md-0" style={{ color: colors.footerColor || '#9ca3af' }}>
                        Pink Peony Shop © 2024. All Rights Reserved
                    </p>
                    <div className="d-flex gap-4 align-items-center">
                        <span className="me-2" style={{ color: colors.footerColor || '#9ca3af' }}>
                            We Are Accepting
                        </span>
                        <div
                            className="border border-gray-600 rounded px-6 py-1 d-flex align-items-center justify-content-center"
                            style={{ minWidth: '36px', height: '22px' }}
                        >
                            <i className="ph-fill ph-apple-logo me-1"></i> Pay
                        </div>
                        <div
                            className="border border-gray-600 rounded px-6 py-1 fw-bold text-center d-flex align-items-center justify-content-center"
                            style={{ minWidth: '36px', height: '22px', fontSize: '9px', fontStyle: 'italic' }}
                        >
                            VISA
                        </div>
                        <div
                            className="border border-gray-600 rounded px-6 py-1 fw-bold text-center d-flex align-items-center justify-content-center"
                            style={{ minWidth: '36px', height: '22px', fontSize: '8px' }}
                        >
                            <span style={{ color: '#ff6600' }}>DISC</span>OVER
                        </div>
                        <div
                            className="border border-gray-600 rounded px-6 py-1 d-flex align-items-center justify-content-center"
                            style={{ minWidth: '36px', height: '22px' }}
                        >
                            <div
                                style={{
                                    width: '10px',
                                    height: '10px',
                                    borderRadius: '50%',
                                    backgroundColor: '#eb001b',
                                    position: 'relative',
                                    left: '2px'
                                }}
                            ></div>
                            <div
                                style={{
                                    width: '10px',
                                    height: '10px',
                                    borderRadius: '50%',
                                    backgroundColor: '#f79e1b',
                                    position: 'relative',
                                    right: '2px',
                                    mixBlendMode: 'screen'
                                }}
                            ></div>
                        </div>
                        <div
                            className="border border-gray-600 rounded px-6 py-1 d-flex flex-column align-items-center justify-content-center"
                            style={{ height: '22px', fontSize: '7px', lineHeight: '1' }}
                        >
                            <span className="d-flex align-items-center">
                                <i className="ph-fill ph-lock-key me-1"></i> Secure
                            </span>
                            <span>Payment</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default TemplateFooter;
